document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-bc-about-slider]').forEach(function (slider) {
    var track = slider.querySelector('[data-bc-about-track]');
    var prevBtn = slider.querySelector('[data-bc-about-prev]');
    var nextBtn = slider.querySelector('[data-bc-about-next]');
    var animating = false;

    function slideStep() {
      var slide = track.firstElementChild;
      var style = getComputedStyle(track);
      var gap = parseFloat(style.columnGap || style.gap || 0);
      return slide.getBoundingClientRect().width + gap;
    }

    function withoutTransition(fn) {
      track.style.transition = 'none';
      fn();
      track.getBoundingClientRect(); // force reflow
      track.style.transition = '';
    }

    function next() {
      if (animating) return;
      animating = true;
      var step = slideStep();

      track.style.transition = 'transform 0.4s ease';
      track.style.transform = 'translateX(-' + step + 'px)';

      track.addEventListener('transitionend', function onEnd() {
        track.removeEventListener('transitionend', onEnd);
        withoutTransition(function () {
          track.appendChild(track.firstElementChild);
          track.style.transform = 'translateX(0)';
        });
        animating = false;
      }, { once: true });
    }

    function prev() {
      if (animating) return;
      animating = true;
      var step;

      withoutTransition(function () {
        track.insertBefore(track.lastElementChild, track.firstElementChild);
        step = slideStep();
        track.style.transform = 'translateX(-' + step + 'px)';
      });

      // force reflow so the browser registers the instant jump before animating back
      track.getBoundingClientRect();

      requestAnimationFrame(function () {
        track.style.transition = 'transform 0.4s ease';
        track.style.transform = 'translateX(0)';
      });

      track.addEventListener('transitionend', function onEnd() {
        track.removeEventListener('transitionend', onEnd);
        animating = false;
      }, { once: true });
    }

    if (nextBtn) nextBtn.addEventListener('click', next);
    if (prevBtn) prevBtn.addEventListener('click', prev);
  });
});
